import axios from 'axios'
import ApiResponse from "@/models/ApiResponse.model.js";

const API_URL = process.env.VUE_APP_API_URL;
const API_URL_APP = process.env.VUE_APP_API_URL_APP;
const APIKEY = process.env.VUE_APP_APIKEY;

class WebApiService {
  async get(url, token, params) {
    return axios({
      method: 'get',
      url: API_URL + url,
      params: params,
      headers: {
        Authorization: APIKEY,
        'Content-Type': 'application/json'
      }
    }).then(
      response => {
        return  new ApiResponse(response.data.status, response.data.Data, response.data.Message);
      } 
    )
    .catch(error => {
      return new ApiResponse(error.response.status, null, error.response.statusText);
    });
  }

  async MyGet(url, params) {
    return axios({
      method: 'get',
      url: API_URL_APP+url,
      params: params,
      headers: {
        Authorization: APIKEY,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    }).then(
      response => {
        return  new ApiResponse(response.status, response.data);
      } 
    )
    .catch(error => {
      return new ApiResponse(error.response.status, null, error.response.statusText);
    });
  }

  async getImage(url, token, params) {

    return axios({
      method: 'get',
      url: API_URL + url,
      params: params,
      responseType:'blob',
      headers: {
        Authorization: APIKEY  
      }
    }).then(
      response => {  
        return  Object.assign(new ApiResponse(), response);
      }
    )
    .catch(error => {           
      return new ApiResponse(error.response.status, null, error.response.statusText);
    });
  }

  async post(url, token, data, params = null) {

    return axios({
      method: 'post',
      url: API_URL + url,
      params: params,
      data: data,
      headers: {
        Authorization: APIKEY,
        'Content-Type': 'application/json'
      }
    }).then(
      response => {        
        return Object.assign(new ApiResponse(), response.data);
      }
    )
    .catch(error => {           
      return new ApiResponse(error.response.status, null, error.response.statusText);
    });
  }

}


export default new WebApiService();